import TileLayer from "ol/layer/Tile";
import WMTS from "ol/source/WMTS";
import WMTSTileGrid from "ol/tilegrid/WMTS";
import { getTopLeft } from "ol/extent";
import { get as getProjection } from 'ol/proj';

export default function(url, layer){

    const resolutions = [3440.640, 1720.320, 860.160, 430.080, 215.040, 107.520, 53.760, 26.880, 13.440, 6.720, 3.360, 1.680, 0.840, 0.420, 0.210];

    var matrixIds = new Array(15);
    for (let z = 0; z < 15; ++z) {
        matrixIds[z] = 'EPSG:28992:' + z;
    }

    const projection = getProjection('EPSG:28992');

    return new TileLayer({
        source: new WMTS({
            url,
            crossOrigin: "anonymous",
            layer,
            matrixSet: 'EPSG:28992',
            format: 'image/png',
            projection: projection,
            tileGrid: new WMTSTileGrid({
                origin: getTopLeft(projection.getExtent()),
                resolutions: resolutions,
                matrixIds: matrixIds
            }),
            style: 'default',
            wrapX: false
        })
    });
}